module.exports = __webpack_public_path__ + "00532729032cd16f4940dc8d2a7dd82b.pdf";